import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const [isExpired, setIsExpired] = useState(false);

  const token = localStorage.getItem("token");
  const expiry = localStorage.getItem("token_expiry");

  useEffect(() => {
    if (token && expiry) {
      const now = Math.floor(Date.now() / 1000);

      if (now > Number(expiry)) {
        localStorage.clear(); 

        setIsExpired(true);
      }
    }
  }, [expiry, token]);

  // No token → redirect
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Expired token → redirect
  if (isExpired) {
    return <Navigate to="/" replace />;
  }

  // Token valid → allow route
  return children;
};

export default ProtectedRoute;
